import 'inventory-listing/components/SearchBar/SearchBar.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { LocaleService, WindowProxy } from '@sm360/widget-commons-core-services';
import { AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';
import * as Actions from 'inventory-listing/actions/listingUsedActions.js';
import { debounce } from 'lodash';

class ListingSearch extends React.Component {
    constructor(props) {
        super(props);
        this.searchChange = this.searchChange.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.updateTextVehicleCriteria = this.updateTextVehicleCriteria.bind(this);
        this.debounceUpdateTextVehicleCriteria = debounce(this.updateTextVehicleCriteria, 400);
        this.searchAnalytics = this.searchAnalytics.bind(this);
        this.debounceSearchAnalytics = debounce(this.searchAnalytics, 5000);

        this.state = {
            text: this.props.textQuery,
        };
    }
    componentWillReceiveProps(newProps) {
        this.setState({
            text: newProps.textQuery,
        });
    }
    onButtonClick() {
        const windowGet = WindowProxy.get();
        if (windowGet) {
            const input = windowGet.document.getElementById('listing-used-payment-search__input');
            if (input) {
                input.value = '';
                this.setState({ text: '' });
                this.props.actions.updateVehicleCriteria(input.value, 'textQuery');
            }
        }
    }

    updateTextVehicleCriteria(text) {
        this.props.actions.updateVehicleCriteria(text, 'textQuery');
    }

    searchAnalytics(text) {
        AnalyticsService.ga4Trigger(TAGS.SEARCH_BAR(text));
        AnalyticsService.ga4Trigger(TAGS.LAYER_NAVIGATION__FILTERS(WindowProxy.location().pathname, 'searchbar'));
    }

    searchChange(event) {
        event.preventDefault();
        this.setState({ text: event.target.value });
        this.debounceUpdateTextVehicleCriteria(event.target.value);
        this.debounceSearchAnalytics(event.target.value);
    }

    render() {
        return (
            <div className="listing-used-payment-search">
                <div className="input-search">
                    <label htmlFor="listing-used-payment-search__input" />
                    <input
                        id="listing-used-payment-search__input"
                        type="text"
                        placeholder={LocaleService.t('LOOKING_FOR')}
                        onChange={(value) => this.searchChange(value)}
                        value={this.state.text}
                    />
                    <button
                        className="input-search__clearbtn"
                        aria-label={LocaleService.t('BUTTONS.CLEAR')}
                        onClick={this.onButtonClick}
                    >
                        <icon className="icon-plus" />
                    </button>
                </div>
            </div>
        );
    }
}
ListingSearch.propTypes = {
    actions: PropTypes.shape({
        updateVehicleCriteria: PropTypes.func.isRequired,
    }),
    textQuery: PropTypes.string,
};
ListingSearch.displayName = 'ListingSearch';
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}
export { ListingSearch };
export default connect(
    null,
    mapDispatchToProps
)(ListingSearch);
